/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const query = window.matchMedia( '(prefers-reduced-motion: reduce)' );

      if ( !query.matches ) {
        $( '.hero-banner' ).each( function() {
          const overlay = $( this ).find( '.hero-banner__load-in-overlay' );
          gsap.to( overlay, {opacity: 0, duration: 2} );
        } );
      } else {
        const overlay = $( '.hero-banner__load-in-overlay' );
        overlay.css( 'display', 'none' );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
